__turbopack_context__.v({
  "imageSliderBlock": "ImageSliderBlock-module__rwGd5a__imageSliderBlock",
  "imageSliderBlock__slider": "ImageSliderBlock-module__rwGd5a__imageSliderBlock__slider",
  "imageSliderBlock__wrapper": "ImageSliderBlock-module__rwGd5a__imageSliderBlock__wrapper",
});
